// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletClientPublicData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.buildCborArray
import org.multipaz.trustmanagement.TrustEntry
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun WalletClientPublicData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "r1pWGvb-WhQNLz2U6buGhz_4J2vXFXE3VVEaedLwpYs")
val WalletClientPublicData_cborSchemaId = ByteString(-81, 90, 86, 26, -10, -2, 90, 20, 13, 47, 61, -108, -23, -69, -122, -121, 63, -8, 39, 107, -41, 21, 113, 55, 85, 81, 26, 121, -46, -16, -91, -117)

fun WalletClientPublicData.Companion.fromCbor(data: ByteArray): WalletClientPublicData {
    return WalletClientPublicData.fromDataItem(Cbor.decode(data))
}

val WalletClientPublicData.Companion.cborSchemaId: ByteString
    get() = WalletClientPublicData_cborSchemaId

fun WalletClientPublicData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("version", this.version.toDataItem())
    val array = this.trustedIssuers.let {
        buildCborArray {
            for (value in it) {
                add(value.toDataItem())
            }
        }
    }
    builder.put("trustedIssuers", array)
    val array0 = this.trustedReaders.let {
        buildCborArray {
            for (value in it) {
                add(value.toDataItem())
            }
        }
    }
    builder.put("trustedReaders", array0)
    return builder.end().build()
}

fun WalletClientPublicData.Companion.fromDataItem(dataItem: DataItem): WalletClientPublicData {
    val version = dataItem["version"].asNumber
    val array1 = dataItem["trustedIssuers"].let {
        buildList<TrustEntry> {
            for (value in it.asArray) {
                add(TrustEntry.fromDataItem(value))
            }
        }
    }
    val trustedIssuers = array1
    val array2 = dataItem["trustedReaders"].let {
        buildList<TrustEntry> {
            for (value in it.asArray) {
                add(TrustEntry.fromDataItem(value))
            }
        }
    }
    val trustedReaders = array2
    return WalletClientPublicData(
        version = version,
        trustedIssuers = trustedIssuers,
        trustedReaders = trustedReaders,
    )
}
